// client/src/PasswordGate.js
// Site-wide gate is disabled; this is a trivial pass-through kept so existing
// imports don't break. If a gate is ever needed again, implement it with real
// authentication (Firebase) rather than a hardcoded client-side password.
import React from 'react';

const PasswordGate = ({ children }) => {
  return <>{children}</>;
};

export default PasswordGate;
